import { ParsedQuery, stringify } from "query-string";
import { FilterConstants } from "../constants/FilterConstants";
import history from "./history";

export const removeEmptyKeysAndUpdateURLWithCombinedParams = (
  paramsFromUrl: ParsedQuery<string>,
  paramsFromReducerPayload: { [key: string]: string }
): { [key: string]: string } => {
  Object.keys(paramsFromReducerPayload).forEach((key) => {
    if (
      key in paramsFromUrl &&
      (paramsFromReducerPayload[key] === "" ||
        typeof paramsFromReducerPayload[key] === "undefined")
    ) {
      delete paramsFromUrl[key];
      delete paramsFromReducerPayload[key];
    }
  });

  history.replace({
    search: stringify(
      { ...paramsFromUrl, ...paramsFromReducerPayload }
    ),
  });

  return paramsFromReducerPayload;
};

export const filterOutParamsNotToClearAndUpdateURL = (
  params: ParsedQuery<string>
): ParsedQuery<string> => {
  Object.keys(params).forEach((key) => {
    if (FilterConstants.ExcludedFromClearing.indexOf(key) === -1) {
      delete params[key];
    }
  });

  history.replace({
    search: stringify({ ...params }),
  });

  return params;
};
